import Styles from './MediaDrawer.module.scss'
import { MediaFile } from '../Carousels/MediaFile'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { LoadingGrid } from './LoadingGrid'
import { SelectMediaProps } from '../Types'

interface Props {
  mediaFiles: IMediaFile[]
  onSelect: (props: SelectMediaProps) => void
  needsDownload?: boolean
  isLoading?: boolean
}

export const MediaFileGrid = ({ mediaFiles, onSelect, needsDownload = false, isLoading = false }: Props) => {
  if (isLoading) return <LoadingGrid />

  return (
    <div className={Styles.mediaGrid}>
      {mediaFiles.map((file, index) => {
        return (
          <div key={index} className={Styles.mediaFileContainer}>
            <MediaFile
              key={file.id}
              file={file}
              src={file.thumbnail_url || file.source_url}
              onPress={() => onSelect({ file, needsDownload })}
            />
          </div>
        )
      })}
    </div>
  )
}
